import { gql } from '@apollo/client'

const SEARCH_JOB_EXECUTIONS = gql`
  query SearchJobExecutions(
    $filter: JobExecutionFilter
    $limit: Int
    $offset: Int
    $orderBy: String
    $orderDirection: String
  ) {
    searchJobExecutions(
      filter: $filter
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      nodes {
        id
        jobName
        status
        payload
        result
        errorMessage
        errorStack
        createdAt
        startedAt
        completedAt
        duration
        createdByUserId
        organizationId
        createdByUser {
          id
          firstName
          lastName
        }
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export default SEARCH_JOB_EXECUTIONS
